import React, { useEffect } from 'react';
import Quicklogin from './quicklogin';
import Maintenance from "./maintenance";
import Webinar from "./webinar";
import Anketa from "./anketa";
import Quiz from "./quiz";

import ReactGA from 'react-ga4';

const GA_TRACKING_ID = 'G-3C52HESZWR'; // <-- replace with your ID

export default function App() {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('p');

    useEffect(() => {
        ReactGA.initialize(GA_TRACKING_ID);
        ReactGA.send({
            hitType: 'pageview',
            page: window.location.pathname + window.location.search,
        });
    }, []);

    switch (page) {
        case 'maintenance':
            return <Maintenance />;
        case 'remote':
            return <Webinar />;
        case 'anketa':
            return <Anketa />;
        case 'quiz':
            return <Quiz />;
        case 'quicklogin':
        default:
            return <Quicklogin />;
    }
}
